import { Lookup } from "./lookup";
import { Suburb } from "./suburbs";

export class RegistrationRequest{
    pharmacyName:string;
    abn:string;
    phone:string;
    fax:string;
    primaryEmail:string;
    invoiceEmail:string;
    headOfficeEmail:string;
    PhARIA:string;
    requestSource:number=806390000;
    pharmacyAddressStreet1:string;
    pharmacyAddressStreet2:string;
    pharmacySuburbId:string;
    pharmacyState:string;
    pharmacyPostCode:string;
    pharmacyAddressCopy:boolean;
    postalAddressStreet1:string;
    postalAddressStreet2:string;
    postalSuburb:Suburb;
    postalState:string;
    postalPostCode:string;
    ahpraNumber:string;
    firstName:string;
    lastName:string;
    contactPreferredName:string;
    mobile:string;
    contactEmailAddress:string;
    contactPersonIsOwner: string | boolean;
    contactPersonIsOwnerString?: string; 
    hasPBSNumber: string | boolean;
    pbsApprovalStatus: number; // CHANGED: Now number instead of string
    pbsApprovalDate:Date;
    pbsApprovalNumber:string;
    pharmacyGuildNumber:string;
    readyToBeAssessed: boolean | string;
    preferredFromDate:any;
    preferredToDate:any
    registrationOwners: RegistrationOwner[];
    registrationStaff: RegistrationStaff[];
    pharmacyStateId: string;
    pharmacyPostCodeId: string;
    postalPostCodeId: string;
    postalStateId: string;
    postalSuburbId:string;
    pharmacySuburb:Suburb;
    belongToGroup:boolean;
    bannerGroupName:string;
    managmentGroupName:string;
    pharmacySignage:boolean;
    bulkBuyingSystem:boolean;
    groupBtandedMedicines:boolean;
    groupBrandedUniform:boolean;
    groupBrandedMarketing:boolean;
    groupManagementSystems:boolean;
    qcppid:string;
    oldpbsnumber:string;
    transferofownership:boolean;
    changeofownership:boolean;
    other:boolean;
    detailsOfOther:string;
    requestType:boolean;
  contactPersonRole?: any = undefined; // Not null, not 0, not ''
  contactPersonOtherRole?: any = undefined; // Not null, not 0, not ''
}

export class RegistrationOwner{
    ownerType:number=806390000;
    firstName:string;
    lastName:string;
    isExistingOwner:string;
    ahpraNumber:string;
    preferredName:string;
    telephone:string;
    fax:string;
    mobileNumber:string;
    emailAddress:string;
    pharmacyAddressStreet1:string;
    pharmacyAddressStreet2:string;
    pharmacySuburb:string;
    pharmacySuburbId:string;
    postalSuburbId:string;
    pharmacyState:string;
    pharmacyStateId:string;
    pharmacyPostCode:string;
    pharmacyPostCodeId:string;
    pharmacyAddressCopy:boolean;
    postalAddressStreet1:string;
    postalAddressStreet2:string;
    postalSuburb:string;
    postalState:string;
    postalStateId:string;
    postalPostCode:string;
    postalPostCodeId:string;
    organisation:string;
    abn:string;
    isPrimaryContact:boolean;
    interestsAsCompany:boolean;
    formEntryOwner:boolean=false;
}

// ADD THIS NEW CLASS FOR STAFF
export class RegistrationStaff {
    firstName:string;
    lastName:string;
    ahpraNumber:string;
    preferredName:string;
    telephone:string;
    fax:string;
    mobileNumber:string;
    emailAddress:string;
    pharmacyAddressStreet1:string;
    pharmacyAddressStreet2:string;
    pharmacySuburb:string;
    pharmacySuburbId:string;
    postalSuburbId:string;
    pharmacyState:string;
    pharmacyStateId:string;
    pharmacyPostCode:string;
    pharmacyPostCodeId:string;
    pharmacyAddressCopy:boolean;
    postalAddressStreet1:string;
    postalAddressStreet2:string;
    postalSuburb:string;
    postalState:string;
    postalStateId:string;
    postalPostCode:string;
    postalPostCodeId:string;
    organisation:string;
    abn:string;
    isPrimaryContact:boolean;
    interestsAsCompany:boolean;
    formEntryOwner:boolean=false;
    // Add any staff-specific properties here
    staffType?: string; // Example: 'Pharmacist', 'Technician', etc.
    position?: string;
}

export class RegistrationRequestResult{
    id: string;
    message:string;
    code:number;
}